import React from 'react';
import Logo from '../Img/Logo_projets&finances.png';
import BilanHypEvolRecDepGestion from '../Graph/Bilan/BilanHypEvolRecDepGestion';
import BilanDepensesPersonnel from '../Graph/Bilan/BilanDepensesPersonnel';
import BilanDynContribDirDot from '../Graph/Bilan/BilanDynContribDirDot';
import { rescueHtml } from '../Components/Tools';

const Page35Graph = (props) => {
    const blue = '#069BD3';

    return (
        <div style={{width: '100%', height: '100%', display: 'flex', flexDirection: 'column'}}>

            {/* Header */}
            <div style={{display: 'flex'}}>
                <div style={{margin: 25}}>
                    <img style={{width: 200}} src={Logo} />
                </div>

                <div style={{flex: 1}}></div>
                
                <div style={{margin: 25}}>
                    <p style={{color: blue, fontSize: 24}}>{rescueHtml(props.user.nom_organisme)}</p>
                </div>
            </div>

            <div style={{borderBottom: '1px solid '+blue, marginLeft: 25}}>
                <p style={{color: blue, fontSize: 26}}>{props.titre}</p>
            </div>


            {/* Container */}
            <div style={{flex: 1, marginTop: 25, height: '80%'}}>
                <div style={{flex: 1, display: 'flex', margin: 25}}>
                    <div style={{flex: 1, margin: 5, marginTop: 50}} className='shadow-md rounded'>
                        <BilanHypEvolRecDepGestion aff={props.aff} setAff={props.setAff} affH1={props.affH1} affH2={props.affH2} affH3={props.affH3} user={props.user} annees={props.annees} height={400}/>
                    </div>
                    <div style={{flex: 1, margin: 5, marginTop: 50}} className='shadow-md rounded'>
                        <BilanDepensesPersonnel aff={props.aff} setAff={props.setAff} affH1={props.affH1} affH2={props.affH2} affH3={props.affH3} user={props.user} annees={props.annees} height={400}/>
                    </div>
                    {props.user.nomen != 'M4' && props.user.nomen != 'M41' && props.user.nomen != 'M43' && props.user.nomen != 'M49'?
                    <div style={{flex: 1, margin: 5, marginTop: 50}} className='shadow-md rounded'>
                        <BilanDynContribDirDot aff={props.aff} setAff={props.setAff} affH1={props.affH1} affH2={props.affH2} affH3={props.affH3} user={props.user} annees={props.annees} height={400}/>
                    </div>
                    :null}
                </div>
            </div>


            {/* Footer */}
            <div style={{display: 'flex', marginBottom: 15}}>
                <div style={{marginLeft: 25}}>
                    <p style={{fontSize: 10}}>{props.date}</p>
                </div>
                <div style={{flex: 1}}></div>
                <div style={{marginRight: 25}}>
                    <p style={{fontSize: 10}}>Page : {props.index}</p>
                </div>
            </div>
        </div>
    );
};

export default Page35Graph;
